import {TAG_TYPES} from '@wix/advanced-seo-utils/renderer'
import {OVERRIDE_IDENTIFIERS} from './seo.identifiers'

export const IDENTIFIER_TO_TAG_TYPE = {
    [OVERRIDE_IDENTIFIERS.LINKS]: TAG_TYPES.LINK,
    [OVERRIDE_IDENTIFIERS.META_TAGS]: TAG_TYPES.META,
    [OVERRIDE_IDENTIFIERS.STRUCTURED_DATA]: TAG_TYPES.SCRIPT
}

export {TAG_TYPES}